export enum DocTypesEnum {
	BillCopyElectric = 105,
	BillCopyGas = 108,
	LOA = 107,
	LOE = 111,
	Other = 114,
	ProxyForm = 205,
}

export class DocType {
	constructor(
		public id: number,
		public value: string,
		public propName: string,
		public maxCount?: number,
	) {}
}
